<template>
    <el-select filterable :filter-method="selectFilter" @visible-change="visibleChange" v-bind="$attrs" v-on="$listeners">
        <el-option v-for="(item, index) in filteredOptions" :key="item[valueKey]" :label="item[nameKey]" :value="item[valueKey]">
            <slot :option="item" :index="index"></slot>
        </el-option>
    </el-select>
</template>

<script>
// import { isNotBlankStr, isString } from '@/util/StringUtils';

export default {
    name: 'SelectFilter',
    props: {
        nameKey: { // 显示名称对应的key
            type: String,
            required: true,
            default: 'name'
        },
        valueKey: { // 绑定值对应的key
            type: String,
            required: true,
            default: 'value'
        },
        options: Array,
        filterKeys: Array // 过滤的属性key
    },
    inheritAttrs: false,
    data() {
        return {
            filterText: ''
        };
    },
    methods: {
        selectFilter(filterText) {
            this.filterText = filterText;
        },
        visibleChange(val) {
            // 如果是隐藏，还原下拉搜索的数据为全部
            if (!val) {
                this.filterText = '';
            }
            this.$emit('visibleChange', val);
        }
    },
    computed: {
        filteredOptions() {
            let arr = this.options;
            let filterText = this.filterText;
            if (this.$isBlank(filterText) || this.$isEmpty(this.filterKeys)) {
                return arr;
            }
            filterText = filterText.toLowerCase();
            return arr.filter((item) => {
                for (let key of this.filterKeys) {
                    let value = item[key];
                    if (isString(value) && isNotBlankStr(value)) {
                        value = value.toLowerCase();
                        if (value.indexOf(filterText) > -1) {
                            return true;
                        }
                    }
                    continue;
                }
                return false;
            });
        }
    }
};
</script>
